app.controller("EditContainerController", ["$scope", "ProgramService", "$uibModalInstance", "$state", "params",
    function ($scope, ProgramService, $uibModalInstance, $state, params) {
        $scope.container = {};
        function fetch() {
            ProgramService.fetchContainer({containerId: params.containerId}).then(function (data) {
                $scope.container = data;
            });
        }

        fetch();

        $scope.update = function () {
            params.method($scope.container).then(function () {
                $uibModalInstance.close();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);